// extracted by mini-css-extract-plugin
export default {"container":"EstablishmentPage_container__2AXQ1","closeButton":"EstablishmentPage_closeButton__oGwMh"};